import { useStore } from '@stores';
import { useEffect, useRef } from 'react';

export const useCreateOrderPresence = (orderId: string | undefined) => {
  const { orderStore } = useStore();

  const hasPresenceRef = useRef(false);

  useEffect(() => {
    if (!orderId) return;

    const deletePresence = () => {
      if (!hasPresenceRef.current) return;

      orderStore.deletePresence({ orderId });

      hasPresenceRef.current = false;
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        deletePresence();
      }
    };

    // ✅ Modal opened (component mounted)
    orderStore.createPresence({ orderId });
    hasPresenceRef.current = true;

    window.addEventListener('beforeunload', deletePresence);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // ✅ Modal closed OR route changed OR component unmounted
    return () => {
      deletePresence();
      window.removeEventListener('beforeunload', deletePresence);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [orderId]);
};
